import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, nullValidation, maybeString, number } from "@altostra/type-validations/lib/primitives";

const nullableString = anyOf(maybeString, nullValidation);

export const isSendOutcomesAbortLogDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      time: string,
      user_id: nullableString,
      canvas_step_name: nullableString,
      outcome: string,
      event_category: nullableString,
      channel: nullableString,
      canvas_step_id: nullableString,
    })
  ),
});
